var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconBellOff = function SvgIconBellOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uEA3D")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Reminder-B",
    transform: "translate(-285.000000, -773.000000)",
    fill: "#959595",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.75,786.025 L290.425,776.225 C290.525001,776.191666 290.649999,776.133334 290.8,776.05 L291.15,775.875 L291.2,775.875 L291.5,775.725 L291.95,775.625 L291.95,774.9 C291.95,774.466664 292.099999,774.095835 292.4,773.7875 C292.700002,773.479165 293.066665,773.325 293.5,773.325 C293.933336,773.325 294.304165,773.479165 294.6125,773.7875 C294.920835,774.095835 295.075,774.466664 295.075,774.9 L295.075,775.625 C296.541674,775.991668 297.691663,776.783327 298.525,778 C299.341671,779.183339 299.75,780.591658 299.75,782.225 L299.75,786.025 Z M293.5,793.65 C292.916664,793.65 292.420835,793.454169 292.0125,793.0625 C291.604165,792.670831 291.4,792.183336 291.4,791.6 L295.6,791.6 C295.6,792.183336 295.395835,792.670831 294.9875,793.0625 C294.579165,793.454169 294.083336,793.65 293.5,793.65 Z M286.475,774.35 L289.15,777.15 L299.681097,787.993908 C300.898084,789.2506 301.962715,790.352627 302.875,791.3 L301.55,792.625 L299.45,790.525 L285.15,790.525 L285.15,789.5 L287.25,787.4 L287.25,782.175 C287.25,780.858327 287.524997,779.666672 288.075,778.6 L285.15,775.725 L286.475,774.35 Z",
    id: "\\uEA3D",
    transform: "translate(294.012500, 783.487500) scale(1, -1) rotate(-180.000000) translate(-294.012500, -783.487500) "
  })))));
};

export default __webpack_public_path__ + "static/media/icon-bell-off.0753bf50.svg";
export { SvgIconBellOff as ReactComponent };